import { z } from "@/zod";
import { ulid } from "./commonFields";

export const dictionary = z.object({
  id: ulid,
  name: z.string().min(1),
});
